
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurDoctors",
  data: () => ({
    teams: [
      {
        id: 5,
        datadelay: "500",
        image: require("../../assets/images/team/member-5.jpg"),
        name: "Maria Ciocan",
        designation: "Psiholog",
        url: "/echipa_medicala/maria_ciocan#echipa_medicala"
      }
    ],
  }),
});
